export const initialValuesSignUp = {
  email: "",
  password: "",
  re_password: "",
  policy: false,
};
